import { dayKey, dayHeading, dayShort, scoreColor } from './helpers';

/**
 * Fil par jour, comme l'historique des QCM (HistoryView, mêmes classes hist-day / hist-timeline / hist-node) :
 * un intitulé par jour (« Aujourd'hui », « Hier », la date) avec le nombre et la moyenne, puis une carte par
 * élément, précédée d'un point coloré selon le score. Sert aux réponses rédigées et aux notions.
 * items : triés du plus récent au plus ancien ; dateOf / pctOf / keyOf lisent un élément ;
 * unit(n) : libellé du compte (« 2 corrections ») ; renderCard(item) : la carte.
 */
export default function DayTimeline({ items, dateOf, pctOf, keyOf, unit, renderCard }) {
    const days = [];
    const map = {};
    for (const it of items) {
        const k = dayKey(dateOf(it));
        if (!map[k]) { map[k] = { key: k, date: dateOf(it), items: [] }; days.push(map[k]); }
        map[k].items.push(it);
    }
    return days.map(day => {
        const avg = Math.round(day.items.reduce((s, it) => s + pctOf(it), 0) / day.items.length);
        const h = dayHeading(day.date);
        const rel = h === "Aujourd'hui" || h === 'Hier';
        return (
            <div key={day.key} className="hist-day-block">
                <div className="hist-day">
                    <span className="hist-day__label">{h}</span>
                    {rel && <span className="hist-day__date">{dayShort(day.date)}</span>}
                    <span className="hist-day__line" />
                    <span className="hist-day__stat">{unit(day.items.length)} · moy. {avg}%</span>
                </div>
                <div className="hist-timeline">
                    {day.items.map(it => (
                        <div key={keyOf(it)} className="hist-node">
                            <span className="hist-node__dot" style={{ background: scoreColor(pctOf(it)) }} />
                            {renderCard(it)}
                        </div>
                    ))}
                </div>
            </div>
        );
    });
}
